import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "more_info";

export class MoreInfoApi {
    static requestMoreInfo(userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}`;
        return authAxios.post(url, userData);
    }
}
